import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.login.modules/ah-helix-widget-loader-module",
  "version": "1.0.0",
  "id": "ahHelixWidgetLoaderModule",
  "containerID": "loginAhHelixWidgetLoaderModule",
  "moduleName": "login-ah-helix-widget-loader-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "ah-helix-widget-loader-module",
  "data": {
    "init": "AhHelixWidgetLoaderModule",
    "options": {
      "js": {
        "indexjs": "/spa/widgets/loader/5.1.2/index.js"
      },
      "loaderVersion": "{{module.loaderVersion}}",
      "clientParams": {
        "skipLoader": "{{module.skipLoader}}"
      }
    }
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "description": "This parameter controls the general color scheme of module. The default is blue, but you can also choose red or green.",
    "default": "blue",
    "values": ["red", "green", "blue"]
  }, {
    "name": "skipLoader",
    "type": "string"
  }, {
    "name": "loaderVersion",
    "type": "string"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.x.x"
  },
  "stores": []
};

/**
 * Implementation of the ah-helix-widget-loader-module module.
 * @copyright 2021-9-27
 * @since 9/27/2021, 4:25:12 PM
 * @author Nidhi Patel
 * @file
 */

/* global Module */

/**
 * The AhHelixWidgetLoaderModule Sparta Module.
 * Helix version of the widget loader module for the Widget
 * @export
 * @class
 */
class AhHelixWidgetLoaderModule extends Module {
  /**
   * Creates an instance of AhHelixWidgetLoaderModule.
   * @memberof AhHelixWidgetLoaderModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const self = this;
    this.basePath = this.getBasePath(this.spaParams);
    this.externalJs = options.js.indexjs;
    this.loaderVersion = options.loaderVersion;
    this.clientParams = options.clientParams;
    this.bindThisConext(['_triggerWidgetLoaded'], self, '');
  }
  bindThisConext(methods, context, suffix = 'Scoped') {
    const self = context;
    console.log(document.getElementById('sampleid'));
    if (methods && $.isArray(methods) && methods.length > 0) {
      $(methods).each((index, method) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }
  getBasePath(spaParams) {
    return _.get(spaParams, 'siteParams.ahServiceEndpoint') || _.get(spaParams, 'siteParams.serviceEndpoint') || _.get(spaParams, 'siteParams.domain.hostname');
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */

  _defineVars() {
    this.widgetsToLoad = [];
    this.WIDGET_CONFIG = {};
    this.WIDGET_PARAMS = {};
    this.selfInitialized = false;
  }
  _initWidget() {
    if (window.sparta && window.sparta.widgetLoader && typeof window.sparta.widgetLoader.load === 'function') {
      this.selfInitialized = true;
    } else {
      if (this.clientParams.skipLoader) {
        return;
      }
      let pathVal = '';
      if (this.basePath) {
        pathVal = window.__swl && __swl.basePath ? __swl.basePath : this.basePath;
      } else {
        pathVal = window.location.origin;
      }
      let widgetSrcPath = [pathVal + this.externalJs];
      const loader = document.createElement('script');
      loader.type = 'text/javascript';
      loader.src = widgetSrcPath;
      document.body.appendChild(loader);
    }
  }
  _loadWidget(params) {
    document.getElementById(params.containerId).style.visibility = 'hidden';
    let pathVal = '';
    if (this.basePath) {
      pathVal = window.__swl && __swl.basePath ? __swl.basePath : this.basePath;
    } else {
      pathVal = window.location.origin;
    }
    let options = {
      name: params.name,
      version: params.version,
      loaderVersion: this.loaderVersion ? this.loaderVersion : '5.1.2',
      container: params.containerId,
      path: pathVal,
      language: params.language || 'en',
      onload: this._triggerWidgetLoaded,
      spinner: false
    };
    window.sparta.widgets[options.loaderVersion].load(options);
  }
  _subscribeEvents() {
    const that = this;
    this.Events.sub('SECURE_AH_WIDGET_LOADER', e => {
      let config = {};
      if (e.data) {
        config = e.data;
      }
      this.WIDGET_CONFIG = {
        name: config.widgetName,
        version: config.widgetVersion,
        containerId: config.ContainerId,
        language: config.language
      };
      this.WIDGET_PARAMS = {
        eventName: config.widgetEventName,
        payload: config.payload,
        successCallback: config.spartaWidgetLoadCallback
      };
      if (window.sparta || window.sparta.widgets) {
        this._loadWidget(this.WIDGET_CONFIG);
        if (!this.selfInitialized) {
          //const that = this;

          that.Events.sub('errorLoadingWidget', function (event) {});
          that.Events.sub('refreshWidget', function (e) {
            document.getElementById(that.WIDGET_CONFIG.containerId).style.visibility = 'visible';
            if (e.detail.name === that.WIDGET_CONFIG.name && e.detail.version === that.WIDGET_CONFIG.version) {
              let _widgetParams = that.WIDGET_PARAMS;
              window.sparta.widgetLoader.pub(_widgetParams.eventName, _widgetParams.payload);
              if (_widgetParams.successCallback) {
                _widgetParams.successCallback();
              }
            }
          });
          this.selfInitialized = true;
        }
      } else {
        this.widgetsToLoad = this.widgetsToLoad || [];
        this.widgetsToLoad.push(this.WIDGET_CONFIG);
      }
    }, true);
  }
  _triggerWidgetLoaded(myWidget) {
    const that = this;
    document.removeEventListener('spartaLoaderLoaded', that);
    this.Events.pub('AHwidgetLoaderReady');
    console.log('myWidget ', myWidget);
    if (this.widgetsToLoad && this.widgetsToLoad.length > 0) {
      this._loadWidget(this.widgetsToLoad.pop());
    }
    myWidget = myWidget;
    var event = new CustomEvent('widgetLoaderReady', {
      detail: {
        widgetLoader: myWidget
      }
    });
    document.dispatchEvent(event); // send handle back to the client for pub/sub communication

    myWidget.events.sub('errorLoadingWidget', function (event) {
      console.log('Error loading widget: ', event.widget.name); // Original event object
      console.log('HTTP code: ', event.xhrReq.status); // Details of the XHR request
    });

    myWidget.events.sub('refreshWidget', function (e) {
      if (!this.WIDGET_CONFIG) {
        console.log('NATIVE: Sparta widget not prepared yet');
        return;
      } else {
        console.log('NATIVE: Sparta widget is prepared, refreshWidget event received');
      }
      if (e.detail.id[0].id === this.WIDGET_CONFIG.containerId && e.detail.name === this.WIDGET_CONFIG.name && e.detail.version === this.WIDGET_CONFIG.version) {
        document.getElementById(this.WIDGET_CONFIG.containerId).style.visibility = 'visible';
        var _widgetParams = this.WIDGET_PARAMS;
        myWidget.events.pub(_widgetParams.eventName, _widgetParams.payload);
        if (_widgetParams.successCallback) {
          _widgetParams.successCallback();
        }
      }
    });
    if (this.selfInitialized) {
      document.getElementById(that.WIDGET_CONFIG.containerId).style.visibility = 'visible';
      var _widgetParams = that.WIDGET_PARAMS;
      myWidget.events.pub(_widgetParams.eventName, _widgetParams.payload);
      if (_widgetParams.successCallback) {
        _widgetParams.successCallback();
      }
    } else {
      myWidget.events.sub('SPARTA_WIDGET_READY.spartaWidgetUtility', function (e) {
        if (!that.WIDGET_CONFIG) {
          console.log('NATIVE: Sparta widget not prepared yet');
          return;
        } else {
          console.log('NATIVE: Sparta widget is prepared, ready event received');
        }
        if (e.detail.widget.name === that.WIDGET_CONFIG.name) {
          document.getElementById(that.WIDGET_CONFIG.containerId).style.visibility = 'visible';
          var _widgetParams = that.WIDGET_PARAMS;
          myWidget.events.pub(_widgetParams.eventName, _widgetParams.payload);
          if (_widgetParams.successCallback) {
            _widgetParams.successCallback();
          }
        }
        this.selfInitialized = true;
      });
    }
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */
  init(options = {}) {
    console.log('Module "ah-helix-widget-loader-module" called with options:', options);
    // document.getElementById("sampleid").innerText = "new text"
    this._defineVars();
    this._initWidget();
    this._subscribeEvents();
  }
}
registerModuleClass({
  moduleClass: AhHelixWidgetLoaderModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { AhHelixWidgetLoaderModule as default, moduleConfig };
